import { render, staticRenderFns } from "./StatusAutomationList.vue?vue&type=template&id=c2c785be&scoped=true&"
import script from "./StatusAutomationList.vue?vue&type=script&lang=js&"
export * from "./StatusAutomationList.vue?vue&type=script&lang=js&"
import style0 from "./StatusAutomationList.vue?vue&type=style&index=0&id=c2c785be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c785be",
  null
  
)

export default component.exports